import React from 'react';
import PropTypes from 'prop-types';
import getTranslatedText from '../../../../helper/get_translated_text';
import { toDangerousReactHtml } from '../../../../helper/to_dangerous_react_html';
import TranslationContainer from '../../../translation/translation_container';
import Translation from '../../../translation/translation';
import { formatToCurrency } from '../../../../../_modules/currency/format_to_currency';
import Tooltip from '../../../tooltip/tooltip';

export const PriceBuy4Pay3 = ({ priceRaw, currencyIsoCode }) => (
    <div className="buy4pay3-price">
        <div className="buy4pay3-price__label">
            <Translation
                translationKey="product-tile-buy4pay3-price-label"
            />
            {' '}
            <Tooltip
                label={getTranslatedText('product-tile-buy4pay3-price-learn-more')}
                content={getTranslatedText('product-tile-buy4pay3-price-learn-more-tooltip')}
                key='product-tile-buy4pay3-tooltip'
                additionalClassNames={['buy4pay3-price__learn-more']}
            />
        </div>
        <div className="buy4pay3-price__value">
            <TranslationContainer
                translationKey="product-tile-current-price"
                targetProperty="dangerouslySetInnerHTML"
                transform={toDangerousReactHtml}
                placeholder={{
                    price: formatToCurrency(
                        (priceRaw * 3) / 4,
                        currencyIsoCode,
                        false,
                        true,
                        { decimalDigits: 2 }
                    )
                }}
            >
                <span className="product-tile__price-current-value" />
            </TranslationContainer>
        </div>
    </div>
);

PriceBuy4Pay3.propTypes = {
    priceRaw: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
};
